<template>
  <section class="bloc-text-image-landscape">
    <AnimatedPath :number="1"/>

    <div class="bloc-text-image-landscape__wrapper">
      <div class="bloc-text-image-landscape__img-ctn">
        <img class=" scroll-step js-scroll-show" :src="require(`@/${content.img}`)">
      </div>
      
      <div class="scroll-step js-scroll-show">
        <h2 class="bloc-text-image-landscape__title" v-html="content.title"></h2>
        <p class="bloc-text-image-landscape__text" v-html="content.text"></p>
      </div>
    </div>
  </section>
</template>

<script>
import AnimatedPath from '@/components/AnimatedPath.vue'

export default {
  name: 'TextImageLandscape',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
  components: {
    AnimatedPath
  }
}
</script>

<style lang="scss">
  .bloc-text-image-landscape {
    width: 100vw;
    background: $th-white;
    padding: rem(75) 0 rem(60);
    overflow: hidden;
    position: relative;

    .animated-path {
      height: calc(100% + 80px) !important;
      position: absolute;
      top: -15px;
      right: 50px;
      width: 300px;

      @include media($from: small) {
        right: 0;
        width: 555px;
      }
    }

    &__wrapper {
      width: grid_m(4.5, 4);
      margin: 0 auto;

      @include media($from: small) {
        width: 100%;
      }
    }

    &__img-ctn {
      width: grid_m(4.5, 4);
      height: grid_m(3, 2);
      display: block;
      position: relative;
      margin: 0 auto;
      margin-bottom: rem(30);
      background: $th-white;

      @include media($from: small) {
        width: grid(8, 7);
        height: grid(5.25, 5);
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &__title {
      @include paragraph($type: 'extrabig-krug-hand', $color: $th-yellow, $uppercase: false);
      position: relative;
      text-align: center;
      display: block;
      font-style: italic;
    }

    &__text {
      @include paragraph($type: 'big', $color: $th-grey, $uppercase: false);
      position: relative;
      text-align: center;
      display: block;
      margin-top: rem(20);

      @include media($from: small) {
        width: grid(7, 6);
        margin: 0 auto;
        margin-top: rem(40);
      }
    }
  }
</style>
